import { Card } from 'antd'
import React, { MutableRefObject, useRef, useState } from 'react'
import './audio-materials.less'

type AudioMaterial = {
  title: string
  audio: string
}

const audioMaterials: AudioMaterial[] = [
  {
    title: "Resurslarni tejash va ilmiy ko'rgazma",
    audio:
      '/audio-materials/1_RESURSLARNI_TEJASH_TA_LIMIY_KO_RGAZMA_Bilim_Makon_youtube.mp3',
  },
  {
    title: "O'zbekiston geometrik mozaikasi",
    audio:
      '/audio-materials/2_O ZBEKISTON_GEOMETRIK_MOZAIKASI - Bilim Makon (youtube).mp3',
  },
  {
    title: "Hikoya tuzing o'yini",
    audio:
      '/audio-materials/3_HIKOYA_TUZING_O YINI - Bilim Makon (youtube).mp3',
  },
  {
    title: "Soatlar rivojlantiruvchi o'yini",
    audio:
      '/audio-materials/4_SOATLAR_RIVOJLANTIRUVCHI_O YINI - Bilim Makon (youtube).mp3',
  },
  {
    title: "Kiyimlar va ilmiy ko'rgazma",
    audio:
      '/audio-materials/5_KIYIMLAR_TA LIMIY_KO RGAZMA - Bilim Makon (youtube).mp3',
  },
  {
    title: "O'zbekiston ramzlari kartochkalar to'plami",
    audio:
      '/audio-materials/6_O_ZBEKISTON_RAMZLARI_KARTOCHKALAR_TO_PLAMI_Bilim_Makon_you.mp3',
  },
  {
    title: "Mayda motorikani rivojlantirish to'qish to'plami",
    audio:
      '/audio-materials/8_MAYDA_MOTORIKANI_RIVOJLANTIRISH_TO_QISH_TO_PLAMI_Bilim_Makon.mp3',
  },
  {
    title: "Hissiyotlar va ilmiy stol o'yini",
    audio:
      '/audio-materials/9_HISSIYOTLAR_TA LIMIY_STOL_O YINI - Bilim Makon (youtube).mp3',
  },
  {
    title: "Ko'p funksiyali pazl o'yini",
    audio:
      '/audio-materials/10_KO P_FUNKSIYALI_PAZL_O YINI - Bilim Makon (youtube).mp3',
  },
  {
    title: 'Koinot',
    audio: '/audio-materials/63 стр Коинот - Bilim Makon (youtube).mp3',
  },
  {
    title: 'Idish tovoqlar',
    audio: '/audio-materials/73стр Идиш товоқлар - Bilim Makon (youtube).mp3',
  },
  {
    title: 'Archa atrofida',
    audio: '/audio-materials/Арча атрофида - Bilim Makon (youtube).mp3',
  },
  {
    title: 'Buyuk bobolarim',
    audio: '/audio-materials/Буюк боболарим - Bilim Makon (youtube).mp3',
  },
  {
    title: 'Yer boyliklari',
    audio: '/audio-materials/Ер бойликлари - Bilim Makon (youtube).mp3',
  },
  {
    title: 'Yordamchi changyutgich',
    audio: '/audio-materials/Ёрдамчи чангютгич - Bilim Makon (youtube).mp3',
  },
  {
    title: "Qor o'yinlari",
    audio: '/audio-materials/Қор ўйинлари - Bilim Makon (youtube).mp3',
  },
  {
    title: "Qo'shni mamlakatlar",
    audio: '/audio-materials/Қўшни мамлакатлар - Bilim Makon (youtube).mp3',
  },
  {
    title: 'Lolalar',
    audio: '/audio-materials/Лолалар - Bilim Makon (youtube).mp3',
  },
  {
    title: 'Non yopkanda oyim',
    audio: '/audio-materials/Нон ёпканда ойим - Bilim Makon (youtube).mp3',
  },
  {
    title: 'Sumalak',
    audio: '/audio-materials/Сумалак - Bilim Makon (youtube).mp3',
  },
  {
    title: "Xushfe'l bo‘lsang sen agar",
    audio: '/audio-materials/Хушфеъл_бўлсанг_сен_агар_Bilim_Makon_youtube.mp3',
  },
  {
    title: 'Harbiy xizmat qilaman',
    audio: '/audio-materials/Ҳарбий_хизмат_қиламан_Bilim_Makon_youtube.mp3',
  },
  {
    title: "Ekologiya qo'shig'i",
    audio: '/audio-materials/Экология қўшиғи - Bilim Makon (youtube).mp3',
  },
  {
    title: "Eng go'zal fasl bahor",
    audio: '/audio-materials/Энг_гўзал_фасл_баҳор_Bilim_Makon_youtube.mp3',
  },
  {
    title: 'Etigim qilar top top',
    audio: '/audio-materials/Etigim qilar top top - Bilim Makon (youtube).mp3',
  },
  {
    title: 'Mening Oilam',
    audio: '/audio-materials/Mening Oilam - Bilim Makon (youtube).mp3',
  },
]

export const AudioMaterials = () => {
  const audioRefs = useRef<HTMLAudioElement[]>([])

  const onPlay = (index: number) => {
    audioRefs.current.forEach((audio, i) => {
      if (audio && i !== index) {
        audio.pause()
        audio.currentTime = 0
      }
    })
  }

  return (
    <div className="audio-materials">
      {audioMaterials.map((audio, idx) => (
        <AudioMaterial
          key={idx}
          audio={audio}
          audioRefs={audioRefs}
          index={idx}
          onPlay={() => onPlay(idx)}
        />
      ))}
    </div>
  )
}

const AudioMaterial = ({
  audio,
  audioRefs,
  index,
  onPlay,
}: {
  audio: AudioMaterial
  audioRefs: MutableRefObject<HTMLAudioElement[]>
  index: number
  onPlay: () => void
}) => {
  const [playing, setPlaying] = useState(false)
  const audioRef = useRef<HTMLAudioElement | null>(null)

  const handlePlay = () => {
    if (audioRef.current) {
      audioRef.current.play()
      setPlaying(true)
      onPlay()
    }
  }

  return (
    <Card
      className="audio-material"
      style={{
        padding: '24px',
        backgroundColor: !playing ? 'white' : '#5092aa91',
      }}>
      <div className="audio-material__content">
        <p className="audio-material__title">{audio.title}</p>
        <audio
          className="audio-material__audio"
          ref={(el) => {
            if (el) {
              audioRefs.current[index] = el
              audioRef.current = el
            }
          }}
          src={audio.audio}
          controls
          onPlay={() => handlePlay()}
          onPause={() => setPlaying(false)}
        />
      </div>
    </Card>
  )
}
